import { Controller } from '@hotwired/stimulus';

// Airbnb-style replace: one paragraph, original or translation, never both.
export default class extends Controller {
  static targets = ['body', 'button', 'showOriginal', 'showTranslation'];
  static values = {
    original: String,
    translation: String,
    originalLang: String,
    translationLang: String
  };

  toggle() {
    const original = this.buttonTarget.getAttribute('aria-pressed') !== 'true';
    const text = original ? this.originalValue : this.translationValue;
    const lang = original ? this.originalLangValue : this.translationLangValue;

    this.bodyTarget.textContent = text;
    this.bodyTarget.setAttribute('lang', lang);
    this.bodyTarget.classList.add('is-expanded');
    this.bodyTarget.classList.remove('is-truncated');

    this.buttonTarget.setAttribute('aria-pressed', original ? 'true' : 'false');
    this.showOriginalTarget.classList.toggle('d-none', original);
    this.showTranslationTarget.classList.toggle('d-none', !original);
  }
}
